import {getApi, postApi} from "../../data/ApiService";
import {CHECK_USER, LOGIN_USER, REGISTER_USER} from "./action_type";
import {SET_AUTH, SET_ERROR, SET_LOADING} from "./mutation_types";


export default {
    async [REGISTER_USER]({commit}, payload) {
        commit(SET_LOADING, true);
        try {
            const response = await postApi('suppliers', payload, {
                'Content-Type': 'multipart/form-data',
            });
            console.log("supplier",response.status);
            commit(SET_AUTH, response.data.accessToken);
            return true;
        } catch (e) {
            commit(SET_ERROR, e.response.data.errors);
            return false;
        } finally {
            commit(SET_LOADING, false);
        }
    },
    async [LOGIN_USER]({commit}, payload) {
        commit(SET_LOADING, true);
        try {
            const response = await postApi('login', payload);
            console.log(response);
            if (response.data.ok) {
                commit(SET_AUTH, response.data.accessToken);
                return true;
            }
            return false;
        } catch (e) {
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    },
    async [CHECK_USER]({commit,state}) {
        commit(SET_LOADING, true);
        try {
            const response = await getApi('me');
            state.user=response.data;
            console.log(response);
        } catch (e) {
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    },
    async logout({commit,state}) {
        localStorage.removeItem("token")       
        location.href="/"
    },
}